export default __webpack_public_path__ + "static/media/SackBrand1.fb4dae63.jpg";